(function ($, window, document) {

function onDOMContentLoaded() {
  function accordion() {
    // handle aria-hidden on collapsed element
    var collapseList = $('.accordion');
    $(collapseList).on('show.bs.collapse', function (event) {
      $(event.target).attr('aria-hidden', false);
    })
    $(collapseList).on('hide.bs.collapse', function (event) {
      $(event.target).attr('aria-hidden', true);
    })
  }

  // collapse when document is ready
  accordion();
}
if (document.readyState == 'loading') {
  document.addEventListener("DOMContentLoaded", onDOMContentLoaded);
} else {
  onDOMContentLoaded();
}

})($, window, document);
